// * FIRESELECTED STORE MODULE
const fireSelected_store = {
    namespaced: true, //to be case sencitive
    // * STATE
    state: {
        fireSelected: {
            users: [],
            total: null
        }
    },
    // * MUTATIONS
    mutations:{
        MUT_fireSelected(state, data) { state.fireSelected = data },
    },
    // * GETTERS
    getters:{
        GET_fireSelected(state) { return state.fireSelected },
    },
    // * ACTIONS
    actions: {
        ACT_fireSelected({commit}, payload){ commit('MUT_fireSelected', payload) },
    }
};
export default fireSelected_store;